import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import HistorySectionDashBoard from "./HistorySectionDashBoard";
import "./CheckInHistoryPage.css";

const CheckInHistoryPage = () => {
  return (
    <main className="checkin-history-page">
      <div className="checkin-history-page__container">
        <Link to="/progress-tracking" className="checkin-history-page__back">
          <ArrowLeft aria-hidden="true" />
          Back to Progress Tracking
        </Link>

        <header className="checkin-history-page__header">
          <p className="checkin-history-page__eyebrow">Saved results</p>
          <h1 className="checkin-history-page__title">Check-in history</h1>
          <p className="checkin-history-page__subtitle">
            Review your previous check-ins and open any result for the full risk summary.
          </p>
        </header>

        <HistorySectionDashBoard showTitle={false} />
      </div>
    </main>
  );
};

export default CheckInHistoryPage;
